export enum ConfigurationFieldFlag {
    Optional = 'Optional',
    Required = 'Required',
}
